export default __webpack_public_path__ + "static/media/image17.50e6b045.png";